module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-solid-900.eot?4184d740eae2fb727bfeab754dcac876";